import React, { createContext, useContext, useEffect, useState } from "react";

export enum Breakpoints {
  XSmall,
  Small,
  Medium,
  Large,
  XLarge,
  XXLarge,
}

const BreakPointContext = createContext<Breakpoints>(Breakpoints.XSmall);

const convertToBreakPoint = (size: number): Breakpoints => {
  const sizes = [576, 768, 992, 1200, 1400];
  for (let i = 0; i < sizes.length; i++) {
    if (size < sizes[i]) {
      return i as Breakpoints;
    }
  }
  return Breakpoints.XXLarge;
};

type Props = {
  width?: number;
};
export const BreakPointProvider: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [breakpoint, setBreakpoint] = useState<Breakpoints>(
    convertToBreakPoint(props.width || window.innerWidth)
  );
  useEffect(() => {
    const handler = (event: UIEvent) => {
      const currentBreakpoint = convertToBreakPoint(window.innerWidth);
      if (currentBreakpoint !== breakpoint) {
        setBreakpoint(currentBreakpoint);
      }
    };
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, [breakpoint]);

  return (
    <BreakPointContext.Provider value={breakpoint}>
      {props.children}
    </BreakPointContext.Provider>
  );
};

export const useBreakPoints = (): Breakpoints => {
  return useContext(BreakPointContext);
};
